<script lang="ts">
  import { page } from '$app/stores';

  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { ThemeToggle } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  import { headerLibs } from '@widgets/header';

  $: institutionLogo = $page.data.configurations.logo;
</script>

<header class="bg-default-50 dark:bg-store-dark sticky top-0 z-20 w-auto transition-transform duration-1000">
  <nav class="font max-w-content mx-auto px-5 text-2xl md:px-8 xl:px-12 2xl:px-0">
    <ul class="grid h-[64px] grid-cols-[1fr_auto_1fr] items-center gap-2 md:h-[72px]">
      <div
        class="{cn('block h-[28px] w-full content-center', {
          'h-full py-2': !institutionLogo,
        })}"
      >
        {#if institutionLogo}
          <DirectusImage
            imageData="{institutionLogo}"
            alt="{institutionLogo.title}"
            imgClasses="w-auto h-full object-contain dark:invert"
            attributes="{{
              draggable: false,
            }}"
            pictureSizes="{{ default: '200px' }}"
            presetKeys="{Preset.Thumbnail}"
          />
        {:else}
          {@const institutionName = $page.data.configurations.name}
          {@const fontSizeStyles = headerLibs.getLogoFontSizeStyles(institutionName)}

          <span class="{fontSizeStyles} block capitalize">{institutionName}</span>
        {/if}
      </div>

      <li class="col-start-3 flex items-center justify-end gap-10">
        <ThemeToggle />
      </li>
    </ul>
  </nav>
</header>
